import { Component } from '@angular/core';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html'
})

export class TermsComponent { }



// WEBPACK FOOTER //
// ./src/components/shared/terms/terms.component.ts